export enum QuoteStatus {
  APPROVED = 'Approved',
  PENDING_APPROVAL = 'Pending Approval',
  PENDING = 'Pending',
  REVISION_PENDING = 'Revision Pending',
}
